import styled from "styled-components"

export const LoginContainer = styled.div`
display: flex;
flex-direction: column;
align-items: center;
max-width: 500px;
margin: auto;

h1{
    align-self: flex-start;
    margin-bottom: 90px;

}

form{
    width: 80%;
    height: 85vh;
    display: flex;
    flex-direction: column;
    justify-content: space-around;
}

p{
    font-size: small;
}

a{
    color: #0202ed;
    font-size: small;
}

`


